import { queryKeys } from "../queryKeys";
import { type ElitePerks, getElitePerks } from "../rest/elite";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetElitePerks = ({
  accountID,
  options,
}: {
  accountID: string;
  options?: QueryOptions<ElitePerks>;
}) => {
  const { data, ...rest } = useRequest(
    queryKeys.elite.perks(accountID),
    () => getElitePerks(accountID),
    {
      ...options,
    },
  );

  return { perks: data, ...rest };
};

export default useGetElitePerks;
